import { useState } from 'react'
import styled from 'styled-components'
import NormalTabs, { TabItemType } from '../../components/TabMenu/normal-tabs'
import { STATICS } from '../../static'
import useVipLevel from '../../hooks/useVipLevel'
import useMyPower from '../../hooks/useMyPower'
import { useVipInfo } from '../../context/VipInfoContext'

const menus: TabItemType[] = [
  {
    title: 'My Member',
    id: 'member',
    // }, {
    //     title: 'My invitation record',
    //     id: 'record'
  },
]

export default function MemberInfo() {
  const [tab, setTab] = useState(menus[0].id)
  return (
    <MemberInfoWrapper>
      <NormalTabs menus={menus} selected={tab} onChange={setTab} />
      {tab === 'member' && <LevelInfo />}
    </MemberInfoWrapper>
  )
}

const MemberInfoWrapper = styled.div`
  width: 1150px;
  min-height: 490px;
  background: #11388c;
  border-radius: 20px;
  margin-top: 40px;
  position: relative;
  padding-bottom: 50px;
`

function LevelInfo() {
  return (
    <>
      <LevelInfoWrapper>
        <LevelPower />
        <Membership />
      </LevelInfoWrapper>
      <Computing />
    </>
  )
}

const LevelInfoWrapper = styled.div`
  width: 1054px;
  height: 410px;
  border-radius: 14px;
  background: linear-gradient(136deg, #2d5fce 0%, #224ba4 100%);
  position: relative;
  margin: 27px auto;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`

function LevelPower() {
  const { level, power } = useVipLevel()
  return (
    <LevelPowerWrapper>
      <LevelPowerItem icon={STATICS.LevelIcon} title={`level-${level}`} text={'My current membership level'} />
      {/*<LevelPowerItem icon={STATICS.IncreaseIcon} title={['5%', '15%', '30%', '50%'][level - 1]} text={'My member’s share of tokens'}/>*/}
      <LevelPowerItem icon={STATICS.PowerIcon} title={`${power} Power`} text={'My total computing power'} />
    </LevelPowerWrapper>
  )
}

const LevelPowerWrapper = styled.div`
  width: 288px;
  height: 410px;
  background: linear-gradient(320deg, #0432c1 0%, #a40ade 100%);
  position: relative;
  padding: 74px 0 78px 34px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
`

function LevelPowerItem(props: { icon: string; title: string; text: string }) {
  return (
    <LevelPowerItemWrapper>
      <img alt={'icon'} src={props.icon} />
      <p className={'title'}>{props.title}</p>
      <p className={'text'}>{props.text}</p>
    </LevelPowerItemWrapper>
  )
}

const LevelPowerItemWrapper = styled.div`
  width: 250px;
  height: 47px;
  position: relative;
  margin-bottom: 50px;

  img {
    width: 40px;
    height: 40px;
    margin-top: 4px;
  }

  p.title {
    font-weight: 600;
    color: #ffffff;
    line-height: 25px;
    font-size: 18px;
    width: 200px;
    position: absolute;
    top: 0;
    left: 54px;
  }

  p.text {
    font-weight: 600;
    color: rgba(255, 255, 255, 0.5);
    line-height: 17px;
    font-size: 12px;
    width: 200px;
    position: absolute;
    bottom: 0;
    left: 54px;
  }
`

function Membership() {
  return (
    <MembershipWrapper>
      <MemberTitle>##VIP Level</MemberTitle>
      <MemberDesc>
        VIP level is determined by computing power
        <br />
        Computing Power=Staking Power( Team’s mining power)+Invitation Power( Lv. 1Count and Lv. 2Count)
        <br />
        <br />
        Stake COCOS for more computing power, leveling up your membership.
        <DetailA target={'_blank'} href={'https://bsc.cocosbcx.io/dividends'}>
          details&gt;&gt;
        </DetailA>
        <br />
        Membership level will be changed dynamically with DAO governance
      </MemberDesc>
      <VipLevelTable />
    </MembershipWrapper>
  )
}

const MembershipWrapper = styled.div`
  height: 100%;
  width: 766px;
  flex: 1;
  position: relative;
  padding: 38px 23px 0 16px;
`

const MemberTitle = styled.h3`
  font-weight: 600;
  color: #ffffff;
  line-height: 20px;
  font-size: 14px;
`

const MemberDesc = styled.p`
  margin-top: 9px;
  font-size: 12px;
  font-weight: 400;
  color: #6090f8;
  line-height: 17px;
`

function VipLevelTable() {
  return (
    <TableWrapper>
      <span>VIP Level</span> <span>Required Power</span> <span>Quota</span>
      <span>Level 4</span> <span>10000</span> <span>50%</span>
      <span>Level 3</span> <span>3000</span> <span>30%</span>
      <span>Level 2</span> <span>500</span> <span>15%</span>
      <span>Level 1</span> <span>0</span> <span>5%</span>
    </TableWrapper>
  )
}

const TableWrapper = styled.div`
  width: calc(203px * 3);
  display: grid;
  grid-template-columns: repeat(3, 203px);
  grid-template-rows: repeat(auto-fill, 44px);
  justify-items: center;
  align-items: center;
  background: #0f3890;
  color: #ffffff;
  font-size: 12px;
  line-height: 44px;
  margin-top: 17px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    top: 44px;
    height: 1px;
    left: 0;
    background: #1c4bb1;
  }
`

function Computing() {
  const { cocosPower, totalPower } = useMyPower()
  return (
    <ComputingWrapper>
      <Title>My Computing Power</Title>
      <SubTitle style={{ marginTop: 27 }}>My staking power</SubTitle>
      <PowerItemList>
        <PowerItem logo={STATICS.CocosPowerLogo} power={cocosPower} desc={'COCOS mining pool'} />
        <PowerItem logo={STATICS.NFTPowerLogo} power={+(totalPower - cocosPower).toFixed(4)} desc={'NFT mining pool'} />
      </PowerItemList>
      <SubTitle style={{ marginTop: 45 }}>My referral power</SubTitle>
      <InvitationPower />
      <Rules>
        <span className={'title'}>Rules for getting NFT staking power</span>
        <br />
        The computing powers of the five NFTs are different. Each COCOS locked equals 1.1 to 1.8 Power...
        <DetailA target={'_blank'} href={'https://docs.cocosbcx.io/products/igo'}>
          details&gt;&gt;
        </DetailA>
        <br />
        <br />
        <span className={'title'}>Rules for staking COCOS:</span>
        <br />
        Different amounts staked result in different powers. Each COCOS staked equals 1 Power...
        <DetailA target={'_blank'} href={'https://docs.cocosbcx.io/products/staking'}>
          details&gt;&gt;
        </DetailA>
      </Rules>
    </ComputingWrapper>
  )
}

const ComputingWrapper = styled.div`
  width: 1054px;
  height: 644px;
  background: linear-gradient(136deg, #2d5fce 0%, #224ba4 100%);
  border-radius: 14px;
  margin: 35px auto 0 auto;
  padding: 23px 42px;
  position: relative;
`

const Title = styled.h3`
  font-weight: 600;
  color: #ffffff;
  line-height: 40px;
  font-size: 28px;
`
const SubTitle = styled.p`
  font-weight: 600;
  color: #ffffff;
  line-height: 20px;
  font-size: 14px;
`

const PowerItemList = styled.div`
  width: 100%;
  height: 122px;
  margin-top: 16px;
  display: flex;
  justify-items: flex-start;
  align-items: center;
`

function PowerItem(props: { logo: string; power: number; desc: string }) {
  return (
    <PowerItemWrapper>
      <PowerLogo src={props.logo} />
      <PowerItemTitle>{props.power} Power</PowerItemTitle>
      <PowerItemDesc>{props.desc}</PowerItemDesc>
    </PowerItemWrapper>
  )
}

const PowerItemWrapper = styled.div`
  width: 336px;
  height: 122px;
  border-radius: 14px;
  border: 1px solid #4b7de6;
  position: relative;
  margin-right: 22px;
  padding: 0px 0 0 25px;
  display: flex;
  justify-items: flex-start;
  align-items: center;
`

const PowerLogo = styled.img`
  width: 75px;
  height: 75px;
  border-radius: 50%;
`

const PowerItemTitle = styled.span`
  position: absolute;
  display: inline-block;
  top: 36px;
  left: 117px;
  font-size: 18px;
  line-height: 25px;
  font-weight: 600;
  color: #fff;
`

const PowerItemDesc = styled.span`
  font-weight: 600;
  color: #6090f8;
  line-height: 17px;
  font-size: 12px;
  top: 69px;
  left: 117px;
  position: absolute;
`

function InvitationPower() {
  const info = useVipInfo()
  return (
    <InvitationPowerWrapper>
      <span className={'power'}>
        {info.lv1Count + info.lv2Count} Invitees = {info.lv1Count * 50 + info.lv2Count * 10} Power
      </span>
      <span className={'tips'}>Total number of invitations</span>
      <span className={'level1'}>
        Level 2 invitation：
        <span>
          {info.lv2Count} Invitees = {info.lv2Count * 10} Power
        </span>
      </span>
      <span className={'level2'}>
        Level 1 invitation：
        <span>
          {info.lv1Count} Invitees = {info.lv1Count * 50} Power
        </span>
      </span>
    </InvitationPowerWrapper>
  )
}

const InvitationPowerWrapper = styled.div`
  width: 909px;
  height: 122px;
  border-radius: 14px;
  border: 1px solid #4b7de6;
  margin-top: 16px;
  position: relative;
  &::before {
    content: '';
    width: 1px;
    height: 70px;
    background: #4b7de6;
    position: absolute;
    top: 26px;
    left: 268px;
  }
  span.power {
    position: absolute;
    top: 34px;
    left: 30px;

    font-size: 18px;
    font-weight: 600;
    color: #fff;
    line-height: 25px;
  }
  span.tips {
    font-weight: 600;
    color: #6090f8;
    line-height: 17px;
    font-size: 12px;
    position: absolute;
    top: 71px;
    left: 30px;
  }
  span.level1,
  span.level2 {
    font-weight: 600;
    color: #6090f8;
    line-height: 20px;
    font-size: 14px;
    position: absolute;
    left: 317px;
    top: 31px;
    span {
      color: #ffd244;
    }
  }
  span.level2 {
    top: 68px;
  }
`

const Rules = styled.p`
  margin-top: 40px;
  font-size: 12px;
  font-weight: 600;
  line-height: 17px;
  color: #6090f8;
  width: 955px;
  padding-right: 20px;
  span.title {
    color: #ffffff;
  }
  span.detail {
    color: #00f4e4;
  }
`

// const DetailLink = styled(Link)`
//   color: #00F4E4;
//   text-decoration: none;
// `
const DetailA = styled.a`
  color: #00f4e4;
  text-decoration: none;
`
